import React from "react";
import VisibilitySensor from "react-visibility-sensor";
import {
  getVisibleSensorAnimation,
  setAdditionalClasses,
} from "../assets/js/utils";

function MediaItem({ icon, value, bottomText, topText, upperIcon }) {
  return (
    <VisibilitySensor partialVisibility>
      {({ isVisible }) => (
        <div
          className={`media-item${setAdditionalClasses(
            ["flex-column"],
            [upperIcon]
          )}`}
          style={getVisibleSensorAnimation(isVisible, "fadeIn 1s")}
        >
          <img
            src={icon}
            alt=""
            className={`media-item__icon${setAdditionalClasses(
              ["mb-10"],
              [upperIcon]
            )}`}
          />

          <div className="media-item_body">
            {topText && <p className="media-item__top-text">{topText}</p>}
            <span className="media-item__value">{value}</span>
            <p
              className={`media-item__bottom-text ${setAdditionalClasses(
                ["fixed-text-width"],
                [upperIcon]
              )}`}
            >
              {bottomText}
            </p>
          </div>
        </div>
      )}
    </VisibilitySensor>
  );
}

export default MediaItem;
